const Privacy = () => {
  return (
    <div className="w-full mt-40">
      <div className="max-w-screen-lg mx-auto">
        <div className="my-4">
          <h2 className="text-2xl font-bold mb-4 w-full text-center">Privacy & Policy</h2>
          <p className="text-md">We do not collect or store personal data.</p>
          <p className="text-md">This extension only processes data required for functionality.</p>
          <p className="text-md">We do not share data with third parties.</p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
